import { createAction } from 'redux-actions';
import { createDeferredAction } from '../../utils/redux';
import { REGION_REGISTRY_MODULE } from '../../configs/moduleNames';
import {
  BEGIN, CLEAR, FAILED, SUCCESSFUL,
} from '../../configs/actionNames';

export const LOAD_SZLT_LIST = '_LOAD_SZLT_LIST';
export const CREATE_SZLT = '_CREATE_SZLT';
export const LOAD_SZLT_BY_ID = '_LOAD_SZLT_BY_ID';
export const ASSIGN_SZLT_BY_ID = '_ASSIGN_SZLT_BY_ID';
export const EDIT_SZLT_BY_ID = '_EDIT_SZLT_BY_ID';
export const ARCHIVE_SZLT = '_ARCHIVE_SZLT';
export const UNARCHIVE_SZLT = '_UNARCHIVE_SZLT';
export const DELETE_SZLT = '_DELETE_SZLT';
export const ANNULMENT_SZLT = '_ANNULMENT_SZLT';
export const LOAD_CARRIER_LIST = '_LOAD_CARRIER_LIST';
export const CREATE_CARRIER = '_CREATE_CARRIER';
export const LOAD_CARRIER_BY_ID = '_LOAD_CARRIER_BY_ID';
export const EDIT_CARRIER_BY_ID = '_EDIT_CARRIER_BY_ID';
export const DELETE_CARRIER = '_DELETE_CARRIER';
export const ANNULMENT_CARRIER = '_ANNULMENT_CARRIER';
export const ARCHIVE_CARRIER = '_ARCHIVE_CARRIER';
export const UNARCHIVE_CARRIER = '_UNARCHIVE_CARRIER';
export const LOAD_VEHICLES_LIST = '_LOAD_VEHICLES_LIST';
export const CREATE_VEHICLES = '_CREATE_VEHICLES';
export const LOAD_VEHICLES_BY_ID = '_LOAD_VEHICLES_BY_ID';
export const EDIT_VEHICLES_BY_ID = '_EDIT_VEHICLES_BY_ID';
export const DELETE_VEHICLES = '_DELETE_VEHICLES';
export const ANNULMENT_VEHICLES = '_ANNULMENT_VEHICLES';
export const ARCHIVE_VEHICLES = '_ARCHIVE_VEHICLES';
export const UNARCHIVE_VEHICLES = '_UNARCHIVE_VEHICLES';
export const VEHICLES_HELPER = '_VEHICLES_HELPER';
export const CARRIER_HELPER = '_CARRIER_HELPER';
export const SZLT_HELPER = '_SZLT_HELPER';
export const LOAD_REGISTRY_HISTORY_LIST = '_LOAD_REGISTRY_HISTORY_LIST';
export const LOAD_REGISTRY_EXPORT_LIST = '_LOAD_REGISTRY_EXPORT_LIST';
export const LOAD_REGISTRY_SMEV_CHECK_LIST = '_LOAD_REGISTRY_SMEV_CHECK_LIST';
export const IMPORT_CARRIER = '_IMPORT_CARRIER';
export const IMPORT_VEHICLES = '_IMPORT_VEHICLES';
export const IMPORT_SZLT = '_IMPORT_SZLT';
export const EXPORT_CARRIER = '_EXPORT_CARRIER';
export const EXPORT_VEHICLES = '_EXPORT_VEHICLES';
export const EXPORT_SZLT = '_EXPORT_SZLT';
export const LOAD_SMEV_CHECK_CARRIER_LIST = '_LOAD_SMEV_CHECK_CARRIER_LIST';
export const LOAD_SMEV_CHECK_SZLT_LIST = '_LOAD_SMEV_CHECK_SZLT_LIST';
export const LOAD_SMEV_CHECK_VEHICLE_LIST = '_LOAD_SMEV_CHECK_VEHICLE_LIST';
export const SMEV_CHECK_ALL_CARRIER = '_SMEV_CHECK_ALL_CARRIER';
export const SMEV_CHECK_ALL_SZLT = '_SMEV_CHECK_ALL_SZLT';
export const SMEV_CHECK_ALL_VEHICLES = '_SMEV_CHECK_ALL_VEHICLES';
export const SEND_VEHICLES_FGIS_TAXI = '_SEND_VEHICLES_FGIS_TAXI';
export const EXTRACT_SZLT = '_EXTRACT_SZLT';
export const EXTRACT_CARRIER = '_EXTRACT_CARRIER';
export const EXTRACT_VEHICLES = '_EXTRACT_VEHICLES';
export const CARRIER_FIELDS_VALIDATION = '_CARRIER_FIELDS_VALIDATION';
export const VEHICLE_FIELDS_VALIDATION = '_VEHICLE_FIELDS_VALIDATION';
export const SZLT_FIELDS_VALIDATION = '_SZLT_FIELDS_VALIDATION';
export const LOAD_RELATION_CARRIER_VEHICLE_LIST = '_LOAD_RELATION_CARRIER_VEHICLE_LIST';
export const LOAD_RELATION_CARRIER_SZLT_LIST = '_LOAD_RELATION_CARRIER_SZLT_LIST';
export const LOAD_RELATION_VEHICLE_SZLT_LIST = '_LOAD_RELATION_VEHICLE_SZLT_LIST';
export const LOAD_CARRIER_LIST_MODAL = '_LOAD_CARRIER_LIST_MODAL';
export const LOAD_SZLT_LIST_MODAL = '_LOAD_SZLT_LIST_MODAL';
export const LOAD_VEHICLES_LIST_MODAL = '_LOAD_VEHICLES_LIST_MODAL';
export const EXPORT_OSAGO = '_EXPORT_OSAGO';
export const IMPORT_OSAGO = '_IMPORT_OSAGO';
export const LOAD_STATUS_IMPORT = '_LOAD_STATUS_IMPORT';

export const loadSZLTList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST);
export const loadSZLTListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + BEGIN);
export const loadSZLTListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + SUCCESSFUL);
export const loadSZLTListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST + FAILED);

export const loadSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID);
export const loadSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID + SUCCESSFUL);
export const loadSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID + FAILED);

export const loadCarrierList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST);
export const loadCarrierListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + BEGIN);
export const loadCarrierListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + SUCCESSFUL);
export const loadCarrierListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST + FAILED);

export const loadCarrierById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID);
export const loadCarrierByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID + SUCCESSFUL);
export const loadCarrierByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID + FAILED);

export const loadVehiclesList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST);
export const loadVehiclesListBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + BEGIN);
export const loadVehiclesListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + SUCCESSFUL);
export const loadVehiclesListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST + FAILED);

export const loadVehiclesById = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID);
export const loadVehiclesByIdSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID + SUCCESSFUL);
export const loadVehiclesByIdFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID + FAILED);

export const vehiclesHelper = createDeferredAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER);
export const vehiclesHelperSuccessful = createAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER + SUCCESSFUL);
export const vehiclesHelperFailed = createAction(REGION_REGISTRY_MODULE + VEHICLES_HELPER + FAILED);

export const carrierHelper = createDeferredAction(REGION_REGISTRY_MODULE + CARRIER_HELPER);
export const carrierHelperSuccessful = createAction(REGION_REGISTRY_MODULE + CARRIER_HELPER + SUCCESSFUL);
export const carrierHelperFailed = createAction(REGION_REGISTRY_MODULE + CARRIER_HELPER + FAILED);

export const szltHelper = createDeferredAction(REGION_REGISTRY_MODULE + SZLT_HELPER);
export const szltHelperSuccessful = createAction(REGION_REGISTRY_MODULE + SZLT_HELPER + SUCCESSFUL);
export const szltHelperFailed = createAction(REGION_REGISTRY_MODULE + SZLT_HELPER + FAILED);

export const sendVehiclesFgisTaxiSuccessful = createAction(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI + SUCCESSFUL);
export const sendVehiclesFgisTaxiFailed = createAction(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI + FAILED);

export const loadCarrierFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION);
export const loadCarrierFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION + SUCCESSFUL);
export const loadCarrierFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION + FAILED);

export const loadVehicleFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION);
export const loadVehicleFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION + SUCCESSFUL);
export const loadVehicleFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION + FAILED);

export const loadSZLTFieldsValidation = createDeferredAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION);
export const loadSZLTFieldsValidationSuccessful = createAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION + SUCCESSFUL);
export const loadSZLTFieldsValidationFailed = createAction(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION + FAILED);

export const loadRelationCarrierVehicleList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST);
export const loadRelationCarrierVehicleSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + SUCCESSFUL);
export const loadRelationCarrierVehicleFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + FAILED);
export const loadRelationCarrierVehicleBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + BEGIN);
export const loadRelationCarrierVehicleClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST + CLEAR);

export const loadRelationCarrierSzltList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST);
export const loadRelationCarrierSzltBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + BEGIN);
export const loadRelationCarrierSzltSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + SUCCESSFUL);
export const loadRelationCarrierSzltFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + FAILED);
export const loadRelationCarrierSzltListClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST + CLEAR);

export const loadRelationVehicleSzltList = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST);
export const loadRelationVehicleSzltListBegin = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + BEGIN);
export const loadRelationVehicleSzltListSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + SUCCESSFUL);
export const loadRelationVehicleSzltListFailed = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + FAILED);
export const loadRelationVehicleSzltListClear = createAction(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST + CLEAR);

export const loadCarrierListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL);
export const loadCarrierListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + BEGIN);
export const loadCarrierListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + SUCCESSFUL);
export const loadCarrierListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL + FAILED);

export const loadSZLTListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL);
export const loadSZLTListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + BEGIN);
export const loadSZLTListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + SUCCESSFUL);
export const loadSZLTListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST_MODAL + FAILED);

export const loadVehiclesListModal = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL);
export const loadVehiclesListModalBegin = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + BEGIN);
export const loadVehiclesListModalSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + SUCCESSFUL);
export const loadVehiclesListModalFailed = createAction(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST_MODAL + FAILED);

export const extractVehiciesById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES);
export const extractVehiciesByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES + SUCCESSFUL);
export const extractVehiciesByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES + FAILED);

export const extractSZLTById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT);
export const extractSZLTByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT + SUCCESSFUL);
export const extractSZLTByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_SZLT + FAILED);

export const extractCarrierById = createDeferredAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER);
export const extractCarrierByIdSuccessful = createAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER + SUCCESSFUL);
export const extractCarrierByIdFailed = createAction(REGION_REGISTRY_MODULE + EXTRACT_CARRIER + FAILED);

export const loadStatusImport = createDeferredAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT);
export const loadStatusImportSuccessful = createAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT + SUCCESSFUL);
export const loadStatusImportFailed = createAction(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT + FAILED);
